import request from '@/util/request'


export const authRuleList = (data) => request.post('/api/authRuleList', data);  //权限列表

export const authRuleAdd = (data) => request.post('/api/authRuleAdd', data);  //权限添加

export const authRuleEdit = (data) => request.post('/api/authRuleEdit', data);  //权限编辑

export const authRuleDel = (query) => request.post('/api/authRuleDel', query);  //权限删除

export const authRuleDetail = (query) => request.post('/api/authRuleDetail', query);  //权限详情